import {ILccaCalculatedImperial} from "@/modules/lcca/interfaces/lccaCalculated";

export const completeLcca = function (scenario: ILccaCalculatedImperial, options: any) {
  // const scenario.= {
  //   beginningAnalysisPeriod: parseInt(options.beginningAnalysisPeriod),
  //   analysisPeriod: parseFloat(options.analysisPeriod),
  //   alternatives: options.alternatives,
  //   discountRate_pct: parseFloat(options.discountRate_pct),
  //   userCostsInAnalysis: options.userCostsInAnalysis,
  //   userCostComputationMethod: options.userCostComputationMethod,
  //
  // }

// const CFYear = []; //cash flow year
  const userCost: number[] = []; //user cost
  const agencyCosts: number[] = []; // agency cost
  const serviceLife: number[] = []; // activity service life
// const agencyMaintenanceCosts = []; //agency maintenance cost
// const maintenanceFrequency = []; // maintenance frequency
  const structuralLife: number[] = []; // structuralLife_yrs

  let totalLife: number = 0;
  let LLife: number = 0;
  let structureLife: number = 0;

  const CFAgencyCost: number[][] = [];
  const CFUserCost: number[][] = [];
  const agencyCost_R: number[][] = [];
  const userCost_R: number[][] = [];

  const discountRate = 0.01;

  /*
  Perform null checks
   */

  if (!scenario.analysisPeriodLength_yrs) {
    throw("Missing data")
  }
  const analysisPeriodLength_yrs = scenario.analysisPeriodLength_yrs;


  for (let i = 0; i < scenario.alternatives.length; ++i) {
    CFAgencyCost[i] = new Array(analysisPeriodLength_yrs + 1); // One per year
    CFUserCost[i] = new Array(analysisPeriodLength_yrs + 1);
    agencyCost_R[i] = new Array(3); // 0 position: agancyCost. 1 position: Discounted agency cost. 2. position: can't tell - comment your code, people!
    userCost_R[i] = new Array(3);
  }

//Fill with zeros
  (scenario.alternatives).forEach(function (alternative, i) {
    for (let j = 0; j < 3; j++) {
      agencyCost_R[i][j] = 0;
      userCost_R[i][j] = 0;
    }

    // one per year
    for (let j = 0; j <= analysisPeriodLength_yrs; j++) {
      CFAgencyCost[i][j] = 0;
      CFUserCost[i][j] = 0;
    }
  });


  scenario.alternatives.forEach(function (alternative, i) {
    const activities = scenario.alternatives[i].activities;
    totalLife = 0;
    for (let j = 0; j < activities.length; j++) {
      if (totalLife >= analysisPeriodLength_yrs) {
        userCost[j] = 0;
        agencyCosts[j] = 0;
        serviceLife[j] = 0;
        structuralLife[j] = 0;
        // maintenanceFrequency[j] = 0;
        // agencyMaintenanceCosts[j] = 0;
      } else {
        if (scenario.userCostComputationMethod === 'Specified') {
          const uwzCost = activities[j].userWorkzoneCost_thousands;
          if (uwzCost !== null) {
            userCost[j] = uwzCost;
          } else {
            userCost[j] = 0;
          }
        } else if (scenario.userCostComputationMethod === 'Calculated') {
          userCost[j] = 0;
        } else {
          userCost[j] = 0;
        }
        agencyCosts[j] = activities[j].agencyConstructionCost_thousands || 0;
        serviceLife[j] = activities[j].serviceLife_yrs;
        structuralLife[j] = activities[j].structuralLife_yrs;

        // maintenanceFrequency[j] = parseInt(activities[j].maintenanceFrequency, 10);
        // agencyMaintenanceCosts[j] = parseInt(activities[j].agencyMaintenanceCost, 10);
        totalLife += serviceLife[j];
      }
    }
    totalLife = 0;
    let j = 0;
    while (totalLife < analysisPeriodLength_yrs && j < activities.length) {
      CFAgencyCost[i][totalLife] += agencyCosts[j];  //Total of Agency Cost
      CFUserCost[i][totalLife] += userCost[j];  //Total of User Cost

      // if(maintenanceFrequency[j] > 0) {
      // 	if(analysisPeriodLength_yrsAP > totalLife + serviceLife_yrs[j]) {
      // 		LLife = totalLife + serviceLife_yrs[j];
      // 	} else {
      // 		LLife = analysisPeriodLength_yrs
      // 	}
      // 	for(k = totalLife+maintenanceFrequency[j]; k <= LLife-1; k += maintenanceFrequency[j]) {
      // 		CFAgencyCost[i][k] = CFAgencyCost[i][k] + agencyMaintenanceCosts[j];
      // 	}
      // }

      structureLife = totalLife + structuralLife[j];
      totalLife += serviceLife[j];


      //TODO: Figure out hout agencyCostRemainingValue is calculated
      // if (structureLife > analysisPeriodLength_yrs) {
      //   //Agency Cost Salvage Value
      //   if (scenario.agencyCostRemainingValue) {
      //     CFAgencyCost[i][analysisPeriodLength_yrs] = CFAgencyCost[i][analysisPeriodLength_yrs] - agencyCosts[j] * (structureLife - analysisPeriodLength_yrs) / structuralLife[j];
      //   }
      //   //User Cost Salvage Value
      //   if (scenario.userCostRemainingValue) {
      //     CFUserCost[i][analysisPeriodLength_yrs] = CFUserCost[i][analysisPeriodLength_yrs] - userCost[j] * (structureLife - data.analysisPeriod) / structuralLife[j];
      //   }
      // }
      j++;
    }
  });

  //Discount rate math
  const r = discountRate ? discountRate : 0; // Discount Rate in decimal, or zero to avoid NANs

  scenario.alternatives.forEach(function (alternative, i) {
    for (let k = 0; k <= analysisPeriodLength_yrs; k++) {
      agencyCost_R[i][0] += CFAgencyCost[i][k];
      agencyCost_R[i][1] += CFAgencyCost[i][k] / (Math.pow((1 + r), k));
      userCost_R[i][0] += CFUserCost[i][k];
      userCost_R[i][1] += CFUserCost[i][k] / (Math.pow((1 + r), k));
    }
    if (Math.abs(r) > 0) {
      agencyCost_R[i][2] = agencyCost_R[i][1] * (r * (Math.pow((r + 1), analysisPeriodLength_yrs)) / (Math.pow((1 + r), analysisPeriodLength_yrs) - 1));
      userCost_R[i][2] = userCost_R[i][1] * (r * (Math.pow((r + 1), analysisPeriodLength_yrs)) / (Math.pow((1 + r), analysisPeriodLength_yrs) - 1));
    } else {
      agencyCost_R[i][2] = agencyCost_R[i][1] / analysisPeriodLength_yrs;
      userCost_R[i][2] = userCost_R[i][1] / analysisPeriodLength_yrs;
    }
  });

  let lowestAgency = 0;
  let lowestUser = 0;

  for (let i = 1; i < scenario.alternatives.length; i++) {
    if (agencyCost_R[lowestAgency][1] > agencyCost_R[i][1]) {
      lowestAgency = i;
    }
    if (userCost_R[lowestUser][1] > userCost_R[i][1]) {
      lowestUser = i;
    }
  }
  const obj = {
    lowestAgencyCost: scenario.alternatives[lowestAgency].name,
    lowestUserCost: scenario.alternatives[lowestUser].name,
    agencyCost_r: agencyCost_R,
    userCost_r: userCost_R
  };

  return obj;
}
